import { TObjectShareResponse } from "../../../../../../services/api/instances/storageApi/types/service_types";

export const parseUsernames = (value: string): string[] =>
  value
    .split(/[\s,]+/)
    .map((name) => name.trim())
    .filter(Boolean);

export const normalizeAutocompleteValue = (values: string[]): string[] => {
  const lastValue = values[values.length - 1];

  if (typeof lastValue === "string" && /[\s,]/.test(lastValue)) {
    return [...values.slice(0, -1), ...parseUsernames(lastValue)];
  }

  return values;
};

export const getUniqueUsernames = (names: string[]) => {
  const seen = new Set<string>();
  const unique = names.filter((v) => {
    const key = v.toLowerCase().replace("@education_tools", "");
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  return unique;
};

export const getAllObjectUsernames = (
  objectId: string,
  allPermissions: TObjectShareResponse[],
) => {
  const permissions = allPermissions.filter(
    (p) => p.object_id === Number(objectId),
  );
  if (!permissions || permissions?.length === 0) return [];
  const usernames = permissions.map((p) =>
    (p.username as string).replace("@education_tools", ""),
  );
  return usernames;
};

export const filterDuplicateUsernames = (
  existingNames: string[],
  newNames: string[],
  currentValues: string[] = [],
): string[] => {
  const currentSet = new Set(
    currentValues?.map((v) =>
      v.toLowerCase().replace("@education_tools", "").trim(),
    ),
  );

  const existingSet = new Set(
    existingNames
      .filter(
        (v) =>
          !currentSet.has(
            v.toLowerCase().replace("@education_tools", "").trim(),
          ),
      )
      .map((v) => v.toLowerCase().replace("@education_tools", "").trim()),
  );

  const uniqueNewNames = getUniqueUsernames(newNames);
  return uniqueNewNames.filter(
    (v) =>
      !existingSet.has(v.toLowerCase().replace("@education_tools", "").trim()),
  );
};
